<div class="table-container" style="overflow:hidden">
  <table class="table-header" sortable-table="sortable-table" (sorted)="onSorted($event)">
    <colgroup>
      <col width="8%"/>
      <col width="10%"/>
      <col width="25%"/>
      <col width="15%"/>
      <col width="30%"/>
    </colgroup>
    <thead>
      <tr>
        <th>
          <mat-checkbox (change)="areAllUsersSelected($event)" [(ngModel)]="allSelected"></mat-checkbox>
        </th>
        <th></th>
        <th sortable-column="nameLabel">NAME</th>
        <th sortable-column="sitesLabel">SITES</th>
        <th></th>
      </tr>
    </thead>
  </table>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-body" style="min-height: 500px">
    <table>
      <colgroup>
        <col width="8%"/>
        <col width="10%"/>
        <col width="25%"/>
        <col width="15%"/>
        <col width="30%"/>
      </colgroup>
      <tbody>
        <ng-container *ngIf="!pagedAppUsers.length">
          <tr *ngIf="!hasReadAppUsersPermission" style="text-align: center; color: #999;">
            <td colspan="11">No Permission for App User List</td>
          </tr>
          <tr *ngIf="hasReadAppUsersPermission" style="text-align: center; color: #999;">
            <td colspan="11">No App User List</td>
          </tr>
        </ng-container>
        <tr class="has-child" *ngFor="let appUsers of pagedItems" (click)="goToDetail(appUsers.user_id)">
          <td>
            <mat-checkbox [(ngModel)]="appUsers.isSelected" (change)="checkIsUsersSelected($event)" (click)="$event.stopPropagation()"></mat-checkbox>
          </td>
          <td><img *ngIf="appUsers.provider_picture" [src]="appUsers.provider_picture" (error)="computedImgError(appUsers)"/></td>
          <td>{{appUsers.email}}</td>
          <td>{{appUsers.site_count}} sites</td>
          <td>
            <div class="more-content v-center" #actionMenus [id]="'appUsers-'+appUsers?.user_id" (mouseenter)="setAppUsersMorePosition(appUsers)"><i class="material-icons-outlined more-icon" [class.show]="appUsers.isShowMenu" (click)="$event.stopPropagation();toggleMenu(appUsers)">more_horiz</i>
              <div class="more appUsers-more" [id]="'appUsers-more-'+appUsers.user_id" [class.visible]="appUsers.isShowMenu">
                <div class="btn-area" style="justify-content: flex-end;flex-direction:column">
                  <div class="text-button mb-7" (click)="$event.stopPropagation(); goToDetail(appUsers.user_id)">
                    <div class="btn-inner">Go to Detail</div>
                  </div>
                  <div class="text-button text-button-danger" *ngIf="hasDeleteAppUsersPermission" (click)="$event.stopPropagation(); deleteSites(appUsers)">
                    <div class="btn-inner">Delete from Sites</div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="pagination-area" style="position: absolute">
  <div style="font-size:12px; margin-right: auto;">{{selectedAppUsers.length}} users selected</div>
  <div class="space"></div>
  <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
    <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
    <div>of </div>
    <div>{{totalSite}}</div>
  </div>
  <div class="pagination">
    <div class="page-mover">
      <div class="btn-area">
        <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
          <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
        </div>
      </div>
      <div class="btn-area">
        <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
          <div class="btn-inner"><span>Next</span>
            <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<dealer-warning [modal]="m_warning"></dealer-warning>